export const aboutIntro = [
  "看料大瓜诞生于一个很朴素的念头：与其等热点炸开之后再回头补课，不如提前把能看到的信号整理清楚。娱乐与商业领域的事件，几乎从来不是突然发生的，它们总会先在一些不起眼的地方留下痕迹——一次被改回去的置顶、一张少了一个名字的座位图、一个突然「调整中」的页面状态。",
  "我们要做的，就是把这些痕迹收集起来，按时间排列，再用尽量克制的语言告诉你：这件事现在走到哪一步了，接下来最值得盯的细节是什么。",
  "我们不生产结论，也不替任何人下判断。每一条前瞻都附上信号清单与时间线，你可以自己验证推理是否成立，也可以在我们判断失误时明确指出。",
];

export const positioningPoints = [
  {
    icon: "ri-focus-3-line",
    title: "面向「提前关注」的需求",
    desc: "服务的不是围观情绪，而是那些希望在事件发酵前就做好准备的人。",
  },
  {
    icon: "ri-article-line",
    title: "只做信息整理，不做八卦消费",
    desc: "讨论事件本身与公开动作，不涉及私人生活，也不煽动对立。",
  },
  {
    icon: "ri-line-chart-line",
    title: "用概率语言描述走向",
    desc: "区分「已确认信号」与「推测方向」，让判断可以被证伪、被复盘。",
  },
];

export const milestones = [
  {
    year: "起步",
    title: "从一个记录表开始",
    desc: "最初只是一个手动维护的信号记录表，用来记录那些被忽略的公开变动。",
  },
  {
    year: "成形",
    title: "时间线方法成型",
    desc: "把零散信号按时间串联后，我们发现很多事件的走向可以被提前看见。",
  },
  {
    year: "扩展",
    title: "覆盖六大领域",
    desc: "从影视扩展到音乐、综艺、直播、商业与文体，形成统一的信号监测方式。",
  },
  {
    year: "现在",
    title: "每天更新前瞻",
    desc: "持续整理正在发酵的线索，并把判断依据完整呈现给每一位蹲守的用户。",
  },
];